import { getElementsById } from "core-integration/src/store/elements/reducers";
import {
  IFixtureAllStat,
  IGroupFixture,
} from "core-integration/src/store/fixtures/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { Key, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { usePlosTranslations } from "../../../../../contexts/PlosTranslationsContext";
import { ToggleButton } from "../../../../ToggleButton";
import { ToggleButtonGroup } from "../../../../ToggleButtonGroup";
import PlayerStatsTable from "./PlayerStatsTable";
import { toggleWrapper, wrapperContainer } from "./playerStatsTable.css";

interface PlayerStatsTableProps {
  fixture: IGroupFixture;
  stats: IFixtureAllStat[];
}

const PlayerStatsTableWrapper = ({ fixture, stats }: PlayerStatsTableProps) => {
  const { fixtures } = usePlosTranslations();
  const [team, setTeam] = useState<string>("all");

  const teamsById = useSelector(getTeamsById);
  const elementsById = useSelector(getElementsById);

  const teamH = teamsById[fixture.team_h];
  const teamA = teamsById[fixture.team_a];

  const filteredStats = useMemo(() => {
    if (team === "all") {
      return stats;
    }
    const teamIdAsNumber = Number(team);
    return stats.filter((s) => elementsById[s.element].team === teamIdAsNumber);
  }, [team, stats]).slice(0, 50);

  const handleChangeTeam = (keys: Set<Key>) => {
    const teamId = keys.values().next().value as string;
    setTeam(teamId);
  };

  return (
    <div className={wrapperContainer}>
      <div className={toggleWrapper}>
        <ToggleButtonGroup
          selectedKeys={new Set([team])}
          onSelectionChange={handleChangeTeam}
        >
          <ToggleButton id={"all"}>{fixtures.all}</ToggleButton>
          <ToggleButton id={`${teamH.id}`}>{teamH.name}</ToggleButton>
          <ToggleButton id={`${teamA.id}`}>{teamA.name}</ToggleButton>
        </ToggleButtonGroup>
      </div>
      <PlayerStatsTable stats={filteredStats} />
    </div>
  );
};

export default PlayerStatsTableWrapper;
